export default __webpack_public_path__ + "0e4da6d967e00b208bbf17d05250060c.svg";